<template>
<div class="chapter">
<div class="inner_page">
<a id="p0"></a>
<blockquote class="sink">
<p class="hang ">The revelation of some uneasy secrets</p>
<p class="hang ">would move most anything, even pigs and fishes,</p>
<p class="hang ">to lift their heads and speak: and at such times</p>
<p class="hang ">it furthers one to cross the great dark water</p>
<p class="hang ">and learn the truth its silent shadows hide.</p>
<div class="timebreak "> </div>
<p class="hang ">In the wet, reedy evening, birdsong echoes,</p>
<p class="hang ">old calling young, eventually answered;</p>
<p class="hang ">while another stands in the dark and calls its fellow,</p>
<p class="hang ">hearing for answer only the ancient silence</p>
<p class="hang ">in which tears fall, under a moon near-full.</p>
<p class="hang ">The lead horse breaks the traces and goes astray</p>
<p class="hang ">to cry its clarion challenge harsh at heaven.</p>
<p class="hang ">Understandably. But can it understand in time</p>
<p class="hang ">the danger that dogs immoderate success? . . .</p>
<div class="timebreak "> </div>
<p class="left indent3"><em>—hexagram 61</em><br/>
“<em>a wind troubles the waters</em>”</p>
<div class="timebreak "> </div>
<p class="left ">If Time has a heart, it is because other hearts stop.</p>
<div class="timebreak "> </div>
<p class="left indent3"><em>—Book of Night with Moon</em><br/>
<em>9.v.IX</em></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front03.vue?6c56bd79